
import Submit from "./submit";
import HeatmapLink from "./heatmaplink";
import {EvalFormat} from "./evalformat";
import {ChartBuilder} from "./chartbuilder";

let windowTimeout = null;

function onClickMeasureHeader(evt, queryDomElement) {
    const name = evt.target.getAttribute("name");

    // they could have clicked the font awesome icon, so we find the closest span
    const span = evt.target.closest("span");

    // remove odl selected
    const tr = span.closest("tr");
    const oldSpan = tr.querySelector(".selected");
    oldSpan.classList.remove("selected");
    const oldI = oldSpan.querySelector("i");
    oldI.classList.replace("fa-eye", "fa-eye-slash");

    span.classList.add("selected");
    span.querySelector("i").classList.replace("fa-eye-slash", "fa-eye");
    updateTimeseries(queryDomElement);

    // in case they checked a box and immediately changed the measure type
    if (windowTimeout != null) {
        clearTimeout(windowTimeout);
        windowTimeout = null;
    }
}

function onClickDimension(evt, queryDomElement) {

    // so we don't refresh multiple times if they change their selection
    if (windowTimeout != null) {
        clearTimeout(windowTimeout);
        windowTimeout = null;
    }

    const table = evt.target.closest("table");
    let checkedCheckBoxes = Array.from(table.querySelectorAll("input[type='checkbox']:checked"));
    if (checkedCheckBoxes.length > 5) {
        // only let them select 5
        evt.target.checked = false;
    } else if (checkedCheckBoxes.length === 0) {
        // if they didn't select anything, don't do anything
    } else {
        windowTimeout = window.setTimeout(function () {
            updateTimeseries(queryDomElement);
        }, 2000);
        //updateTimeseries(queryDomElement);
    }
}

function transpose(a) {
    return Object.keys(a[0]).map(function(c) {
        return a.map(function(r) { return r[c]; });
    });
}

function resetOpacity(opacity, el) {
    opacity = opacity||"100%";
    el.style.opacity = opacity;
}

function toggleNoData(queryDomElement, visible) {
    let contentBox = queryDomElement.closest(".content-box");
    let chartNoData = contentBox.querySelector(".chart-no-data");
    let chartLoading = contentBox.querySelector(".chart-loading");

    chartLoading.style.display = "none";
    chartNoData.style.display = visible ? "block" : "none";
}

async function updateTimeseries(queryDomElement) {
    // get selected measure name from dom

    let selectedMeasureDomElement = queryDomElement
        .parentNode
        .querySelector(".selected");

    if (selectedMeasureDomElement == null) {
        document.querySelector("#timeseries-details-container").innerHTML = "";
        return;
    }


    let measureName = selectedMeasureDomElement.getAttribute("name");

    let measureFragment = queryDomElement
        .parentNode
        .querySelector(`[type='measure/fragment'][data-measure='${measureName}']`)
        .innerText;

    let checkedCheckBoxes = Array.from(queryDomElement.parentNode.querySelectorAll("input[type='checkbox']:checked"));
    let predicates = checkedCheckBoxes.map(el => el.getAttribute("data-predicate"));
    let categories = checkedCheckBoxes.map(el => el.getAttribute("data-category"));

    let projection = [];
    for (let i=0;i<predicates.length;++i) {
        projection.push(
            measureFragment.replaceAll("#predicate", predicates[i]) + " as \"" + categories[i] + "\""
        )
    }

    projection = projection.join(", ");

    const contentBox = document.querySelector("#timeseries-details-container").closest(".content-box");
    resetOpacity("25%", contentBox);

    let timeseriesFragment = queryDomElement
        .parentNode
        .querySelector("script[type='timeseries/fragment']")
        .innerText;

    let timeseriesQuery = timeseriesFragment.replace("#projection", projection);


    // execute query
    const response = await Submit.submit(timeseriesQuery, "data/query");
    let transposed = transpose(response.rows);

    // pluck off the first columns
    let timeColumnName = response.headers.shift();
    let _categories = transposed.shift();

    let builder = new ChartBuilder();

    // collect the timeseries
    for (let i=0;i<transposed.length;++i)
        builder.addSeries(response.headers[i], transposed[i]);

    builder.setLabels(_categories);

    // accessible within eval scripts
    let fmt = EvalFormat;

    let valueFormatter = document.querySelector("script[type='value/formatter'][data-measure='" + measureName + "']");
    if (valueFormatter)
        builder.setYAxisFormat(eval("(" + valueFormatter.innerText + ")"));

    // get or create div that exists as a child right before the script element
    let containerElement = document.querySelector("#timeseries-details-container");

    // clear content and add a new chart
    containerElement.innerHTML = "";

    containerElement.classList.add("timeseries-chart-container");
    let canvas = document.createElement("canvas");
    containerElement.appendChild(canvas);
    builder.build(canvas);

    // update the measure name
    document.querySelector("#timeseries-measure").innerText = measureName;

    resetOpacity("100%", contentBox);
}

function createTable(queryDomElement, rows, headers) {

    let domTable = queryDomElement.parentNode.querySelector("table");

    toggleNoData(queryDomElement, false);

    if (rows.length === 0) {
        // create no data message if there are no rows
        toggleNoData(queryDomElement, true);

        // hide the table if it was created
        if (domTable != null)
            domTable.remove();

        return;
    }


    const table  = document.createElement("table");
    table.classList.add("small-stats-table");
    table.classList.add("negative-th-margin");
    table.classList.add("right-align-th");

    // thead
    const tableHead = document.createElement("thead");
    const tr = document.createElement("tr");
    for (let c=0;c<headers.length;++c) {
        const td = document.createElement("th");

        if (headers[c] !== "") {
            const span = document.createElement("span");
            span.onclick = function(evt) {
                onClickMeasureHeader(evt, queryDomElement);
            }
            span.setAttribute("name", headers[c]);
            if (c === 1) {
                span.classList.add("selected");
                span.innerHTML = "<i class=\"fa-solid fa-eye\"></i> " + headers[c];
            } else {
                span.innerHTML = "<i class=\"fa-solid fa-eye-slash\"></i> " + headers[c];
            }
            td.appendChild(span);
        }

        tr.appendChild(td);
    }

    tableHead.appendChild(tr);
    table.appendChild(tableHead);

    // tbody
    const tableBody = document.createElement("tbody");
    for (let r=0;r<rows.length;++r) {
        const tr = document.createElement("tr");

        for (let c=0;c<rows[r].length;++c) {
            const td = document.createElement("td");

            if (c !== 0)
                td.style.textAlign = "right";

            if (typeof rows[r][c] == "number") {
                rows[r][c] = rows[r][c].toLocaleString();
            }

            if (rows[r][c] instanceof HTMLElement)
                td.appendChild(rows[r][c]);
            else
                td.innerHTML = rows[r][c];
            tr.appendChild(td);
        }

        tableBody.appendChild(tr);
    }

    table.appendChild(tableBody);

    if (domTable == null) {
        queryDomElement.parentNode.appendChild(table);
    } else {
        domTable.replaceWith(table);
    }
}

function dimensionPredicate(dims, row) {
    let predicates = [];
    for (let entry of dims.entries()) {
        const dimName = entry[0];
        const dimIndex = entry[1];
        let dimValue = row[dimIndex];

        // dimensions like screenWidth/screenHeight can be numbers
        if (typeof dimValue === "string")
            dimValue = dimValue.replace("\"","\\\"");

        predicates.push(`${dimName} = "${dimValue}"`);
    }
    return predicates.join(" and ");
}

async function loadFromDomScript(queryDomElement) {
    const response = await Submit.submit(queryDomElement.innerText, "data/query");

    // get row formatter
    let rowFormatterScript = queryDomElement
        .parentNode
        .querySelector("script[type='row/formatter']")
        .innerText;

    let categoryFormatterScript = queryDomElement
        .parentNode
        .querySelector("script[type='category-name/formatter']")
        .innerText;

    let measureColumns = queryDomElement
        .getAttribute("data-measures")
        .split(",")
        .map(item => item.trim());

    let dims = queryDomElement
        .getAttribute("data-dims")
        .split(",")
        .map(dim => dim.trim())
        .map(dim => [dim, response.headers.indexOf(dim)]);
    dims = new Map(dims);

    // accessible within eval scripts
    let fmt = EvalFormat;

    let rowTransformer = eval("(" + rowFormatterScript + ")");
    let categoryTransformer = eval("(" + categoryFormatterScript + ")");


    let rows = [];
    for (let i=0;i<response.rows.length;++i) {
        let transformedRow = rowTransformer(response.rows[i]);
        let transformedCategory = categoryTransformer(response.rows[i]);
        let predicate = dimensionPredicate(dims, response.rows[i]);

        // we need to set onclick, and we can't just do that with html.  so we end up parsing the html, finding the
        // dom elements we need and adding attributes.
        const parser = new DOMParser();
        const doc = parser.parseFromString(transformedRow[0], 'text/html');
        let firstColumn = doc.body.childNodes[0];

        // input
        let input = doc.querySelector("input");
        if (input !== null) {
            input.setAttribute("type", "checkbox");
            input.setAttribute("data-predicate", predicate);
            input.setAttribute("data-category", transformedCategory);
            input.onclick = function (evt) {
                onClickDimension(evt, queryDomElement);
            };
            if (i < 5)
                input.checked = true;
        }

        // heatmap link
        HeatmapLink.installClickHandler(doc);

        transformedRow[0] = firstColumn;
        rows.push(transformedRow);
    }

    createTable(queryDomElement, rows, ["", ...measureColumns]);
    await updateTimeseries(queryDomElement);
}

const DetailsQuery = {
    "loadFromDomScript": loadFromDomScript
};

export default DetailsQuery;